import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type1 from "../../assets/car-type2.avif";
import type2 from "../../assets/suv-type.webp";
import type4 from "../../assets/suv-type2.jpg";
import type3 from "../../assets/electric-type.avif";
import { MdOutlineArrowCircleRight } from "react-icons/md";
import { getCategories } from "../../redux/Slice/configSlice";
// import AOS from 'aos';
// import 'aos/dist/aos.css';
import { Link, useNavigate } from "react-router-dom";
import { clearSearchQuery, setCarCategoryId } from "../../redux/Slice/carSlice";
const CarTypeSection = () => {
  const dispatch = useDispatch();
  const typeData = useSelector((state) => state?.config?.categories);

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getCategories());
  }, []);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  const carCategoryhandler = (id) => {
    scrollToTop();
    dispatch(clearSearchQuery());
    dispatch(setCarCategoryId(id));
    navigate("/carlist");
  };

  return (
    <div className="container my-6 pb-5">
      <h1 className="text-center accentColor mb-5 font">
        Our Wide Range Of Vehicle
      </h1>
      <div className="row">
        {typeData?.map((data) => (
          <div
            className="col-lg-6 gy-3 position-relative text-capitalize"
            key={data?._id + data?.categoryName}
          >
            <img
              alt={`${data?.categoryName}`}
              className="img-type rounded-5"
              src={type1}
            />

            <span onClick={() => carCategoryhandler(data?._id)}>
              <h2 className="type-name">
                {data?.categoryName} <MdOutlineArrowCircleRight />
              </h2>
            </span>
          </div>
        ))}
        {/* <div className='col-lg-6 gy-3 position-relative' >
          <img className='img-type rounded-5' src={type2} />
          <Link to="/carlist" onClick={scrollToTop} ><h2 className='type-name' >VAN <MdOutlineArrowCircleRight /></h2></Link>
        </div>
        <div className='col-lg-6 gy-3 position-relative' >
          <img className='img-type rounded-5' src={type4} />
          <Link to="/carlist" onClick={scrollToTop} ><h2 className='type-name' >SUV <MdOutlineArrowCircleRight /></h2></Link>
        </div>
        <div className='col-lg-6 gy-3 position-relative' >
          <img className='img-type rounded-5' src={type3} />
          <Link to="/carlist" onClick={scrollToTop} ><h2 className='type-name' >ELECTRIC <MdOutlineArrowCircleRight /></h2></Link>
        </div> */}
      </div>
    </div>
  );
};

export default CarTypeSection;

// import React, { useState, useEffect } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import type1 from '../../assets/car-type2.avif'
// import type2 from '../../assets/suv-type.webp'
// import type4 from '../../assets/suv-type2.jpg'
// import type3 from '../../assets/electric-type.avif'
// import { MdOutlineArrowCircleRight } from "react-icons/md";
// import { setCarCategoryId } from "../../redux/Slice/carSlice";
// // import AOS from 'aos';
// // import 'aos/dist/aos.css';
// import { Link } from 'react-router-dom'

// const CarTypeSection = () => {
//   const dispatch = useDispatch();
//   const typeData = useSelector((state) => state?.car?.typeData?.data)
//   // carCategoryId?._id
//   useEffect(() => {
//     dispatch())
//   }, []);

//   const carCategoryhandler=(id)=>{
//     scrollToTop();
//     dispatch(setCarCategoryId(id))

//   }

//   const scrollToTop = () => {
//     window.scrollTo(0, 0)
//   }

//   return (
//     <div className='container my-6 pb-5' >
//       <h1 className='text-center accentColor mb-5 font' >Our Wide Range Of Vehicle</h1>
//       <div className='row' >
//         {typeData?.map((data) => (
//           <div className='col-lg-6 gy-3 position-relative' >
//             <img className='img-type rounded-5 ' src={type1} />
//             <Link to={`/carlist`} onClick={()=>carCategoryhandler(data?.carCategoryId?._id)} ><h2 className='type-name' >{data?.carCategoryId?.categoryName} <MdOutlineArrowCircleRight /></h2></Link>
//           </div>
//         ))}
//         {/* <div className='col-lg-6 gy-3 position-relative' >
//           <img className='img-type rounded-5' src={type2} />
//           <Link to="/carlist" onClick={scrollToTop} ><h2 className='type-name' >VAN <MdOutlineArrowCircleRight /></h2></Link>
//         </div>
//         <div className='col-lg-6 gy-3 position-relative' >
//           <img className='img-type rounded-5' src={type4} />
//           <Link to="/carlist" onClick={scrollToTop} ><h2 className='type-name' >SUV <MdOutlineArrowCircleRight /></h2></Link>
//         </div>
//         <div className='col-lg-6 gy-3 position-relative' >
//           <img className='img-type rounded-5' src={type3} />
//           <Link to="/carlist" onClick={scrollToTop} ><h2 className='type-name' >ELECTRIC <MdOutlineArrowCircleRight /></h2></Link>
//         </div> */}
//       </div>
//     </div>
//   )
// }

// export default CarTypeSection
